
import createClient from '../../apolloClient';
import ME_QUERY from '../../query/me';

const fetchMe = async (key) => {
  const client = createClient();
  const result = await client.query({
    query: ME_QUERY(key),
  });
  const { me } = result?.data || {};
  return me;
};

export default fetchMe;
